import _ from 'lodash'

function objectDiff(a, b) {
  return _.fromPairs(
    _.differenceWith(_.toPairs(a as never), _.toPairs(b as never), _.isEqual)
  )
}

export { objectDiff }
